webpackJsonp([16],{

/***/ 872:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_on_vue_multiselect__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel_3d__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_on_sortObjects__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_on_sortObjects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_js_on_sortObjects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_async__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_js__ = __webpack_require__(135);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "columnCharts",
  components: { Carousel3d: __WEBPACK_IMPORTED_MODULE_3_vue_carousel_3d__["Carousel3d"], Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel_3d__["Slide"], MultiSelect: __WEBPACK_IMPORTED_MODULE_1__assets_js_on_vue_multiselect__["a" /* default */], vueSlider: __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default.a },

  props: ["optionsIndicator", "meta_data", "appData", "dashboardStateOptions", "contextSelectedIndicator", "optionSourcess"],
  data: function data() {
    return {
      // fullscreen: true,
      click: 1,
      selectedYear: "",
      optionYear: [],
      dataSource: [],
      columns: [],
      optionsSource: [],
      optionSources: ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS", "World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],

      optionIndicators: [],
      tableColumnHeaderAttr: [],
      collapsible: true,
      selectedSource: { name: "MICS:2021" },
      selectedIndicator: { name: "MICS:2021" },
      optionStates: ["National", "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
      optionsYear: [2013, 2014, 2015, 2016, 2017],
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      metaData: JSON.parse(this.$ls.get("meta_data_dataset")),

      nationalTarget: "",
      sdgTarget: "",
      optionsObj: {
        chart: {
          type: "column",
          zoomType: "xy",
          height: 400
        },
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              chart: {
                type: "bar",
                height: 850
              },
              xAxis: {
                type: "category",

                labels: {
                  rotation: 0,
                  style: {
                    fontSize: "9px",
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: "600"
                  }
                }
              }
            }
          }]
        },
        title: {
          text: "Loading...",
          style: {
            fontSize: "16px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600"
          }
        },
        subtitle: {
          text: ""
        },
        colors: ["#17606B", "#E85D58", "#58B74E", "#58A5E8", "#CF3C64", "#BB7A17"],
        xAxis: {
          type: "category",

          labels: {
            rotation: -45,
            style: {
              fontSize: "11px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal"
            }
          }
        },
        credits: {
          enabled: false
        },
        yAxis: {
          min: 0,
          title: {
            text: "Values",
            style: {
              fontSize: "11px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal"
            }
          },
          gridLineWidth: 0,
          labels: {
            style: {
              fontSize: "11px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal"
            }
          }
        },
        plotOptions: {
          series: {
            grouping: true,
            shadow: false,
            pointWidth: 8,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "{point.y:.1f}",
              style: {
                fontSize: "8px",
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: "normal",
                color: "#333333"
              }
            }
          }
        },

        tooltip: {
          pointFormat: "{series.name}: <b>{point.y:.1f} </b>"
        },
        series: [],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "openInCloud"],

              symbol: "download"
            }
          }
        }
      },

      dataSources: ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS", "World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],
      // dataSourceDescription: {
      //   mics: "MICS", nhmis: 'NHMIS', nnhs: 'NNHS', ndhs: 'NDHS', nmis: 'NMIS', narhs: 'NARHS',
      //   world_bank: 'World Bank', ihme: 'IHME', ihme_sdg: 'IHME-SDG', who: 'WHO-GHO', wuenic: 'WUENIC', pccs: 'PCCS', unaids: 'UNAIDS', nhspss: 'NHSPSS', nha: 'NHA', kdghs: 'KDGHS', naiis: 'NAIIS'
      // }, // , ibbs:'IBBS'
      tempData: "",
      multiselectPlaceholder: "",
      sourceMultiselectPlaceholder: ""
    };
  },

  methods: {
    openedMultiselect: function openedMultiselect() {
      this.multiselectPlaceholder = "Search indicators";
    },
    closedMultiselect: function closedMultiselect(e) {
      this.multiselectPlaceholder = e;
    },
    openedSourceMultiselect: function openedSourceMultiselect() {
      this.sourceMultiselectPlaceholder = "Search data source";
    },
    closedSourceMultiselect: function closedSourceMultiselect(e) {
      this.sourceMultiselectPlaceholder = "";
      // console.log(e)
    },
    multiselectSearch: function multiselectSearch() {
      this.collapsible = false;
    },
    getDisplayFactor: function getDisplayFactor() {
      var displayFactor = "";
      for (var i in this.metaData) {
        if (this.metaData[i][0] === this.selectedIndicator.name) {
          displayFactor = this.metaData[i][3];
          break;
        }
      }
      this.optionsObj.yAxis.title.text = displayFactor;
    },
    removeArrayElementByValue: function removeArrayElementByValue(arr) {
      var what,
          a = arguments,
          L = a.length,
          ax;
      while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1);
        }
      }
      return arr;
    },
    getCurrentSourceOptions: function getCurrentSourceOptions() {
      var _this = this;

      var sourceYear = {};
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      this.optionStates.map(function (element, index) {
        var selectedStateByIndicatorByYear = statesByIndicatorByYear[element];
        _this.dataSources.map(function (elem, index) {
          var indicatorSource = _this.selectedIndicator.name + " -> " + elem;
          if (!sourceYear[elem]) sourceYear[elem] = _this.getYearOptions(selectedStateByIndicatorByYear, indicatorSource);
        });
      });
      var tempOptions = {};
      var multiselectOptions = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sourceYear).map(function (elem, index) {
        if (sourceYear[elem].length > 0) {
          tempOptions.sources = elem;
          tempOptions.years = [];

          sourceYear[elem].forEach(function (el, i) {
            tempOptions.years.push({ name: elem + ":" + el });
          });
          multiselectOptions.push(tempOptions);
        }
        tempOptions = {};
      });

      this.optionsSource = multiselectOptions;
    },
    plotZonalChart: function plotZonalChart() {
      var _this2 = this;

      var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[this.selectedIndicator.name];
      var vt = ivt[1] === "P" ? "%" : "";
      var it = ivt[1] === "P" ? "% of total" : "";
      this.optionsObj.tooltip.pointFormat = '<span style="color:black; font-family: "Open Sans", sans-serif; font-weight: bold;"><b>{point.y:.2f}' + it + "</b> </span><br/>";
      this.optionsObj.plotOptions.series.dataLabels.format = "{point.y:.1f}" + vt;
      this.optionsObj.plotOptions.series.pointWidth = 8;
      this.optionsObj.title.text = this.selectedIndicator.name;
      this.getCurrentSourceOptions();
      this.optionsObj.series = [];
      this.optionsObj.exporting.filename = this.selectedIndicator.name + " " + this.selectedSource.name;
      if (Array.isArray(this.selectedSource)) {
        var series_value = this.getChartData(this.selectedSource[0].name);
        series_value.forEach(function (el, i) {
          if (el === "") {
            el = 0;
          }
        });
        var series_data = {
          name: this.selectedSource[0].name,
          data: this.getChartData(this.selectedSource[0].name)
        };
        this.optionsObj.series.push(series_data);
      } else {
        var series_value = this.getChartData(this.selectedSource.name);
        series_value.forEach(function (el, i) {
          if (el === "") {
            el = 0;
          }
        });
        var series_data = {
          name: this.selectedSource.name,
          data: this.getChartData(this.selectedSource.name)
        };

        this.optionsObj.series.push(series_data);
      }
      var nationalTarget = void 0;
      var sdgTarget = void 0;

      this.meta_data.map(function (elem) {
        if (_this2.selectedIndicator.name == elem[0]) {
          nationalTarget = elem[7];
          sdgTarget = elem[10];

          _this2.nationalTarget = nationalTarget;
          _this2.sdgTarget = sdgTarget;
        }
      });

      this.optionsObj.yAxis.plotLines = [];
      var nationalTargetLine = {
        id: "nationalLineID",
        color: "#222222",
        width: 0.5,
        value: this.nationalTarget,
        label: {
          text: "NT: " + this.nationalTarget + vt, // vt is value type; whether percentage or number
          align: "right",
          rotation: 0,
          y: -10,
          x: 0
        }
      };

      var sdgTargetLine = {
        id: "sdgLineID",
        color: "#222222",
        width: 0.5,
        value: this.sdgTarget,
        dashStyle: "longdashdot",
        label: {
          text: "SDG: " + this.sdgTarget + vt, // vt is value type; whether percentage or number
          align: "right",
          rotation: 0,
          y: 15,
          x: 0
        }
      };
      if (this.nationalTarget) {
        this.optionsObj.yAxis.plotLines.push(nationalTargetLine);
      }

      if (this.sdgTarget) {
        this.optionsObj.yAxis.plotLines.push(sdgTargetLine);
      }
    },
    onSourceChangedMethod: function onSourceChangedMethod() {
      //Set highchart options for cases when this method is called first
      var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[this.selectedIndicator.name];
      var vt = ivt[1] === "P" ? "%" : "";
      var it = ivt[1] === "P" ? "% of total" : "";
      this.optionsObj.tooltip.pointFormat = '<span style="color:black; font-weight: bold;"><b>{point.y:.2f}' + it + "</b> </span><br/>";
      this.optionsObj.plotOptions.series.dataLabels.format = "{point.y:.1f}" + vt;
      this.optionsObj.series = [];
      this.optionsObj.plotOptions.series.pointWidth = 8 - this.selectedSource.length;
      this.optionsObj.title.text = this.selectedIndicator.name;

      for (var j in this.selectedSource) {
        var series_value = this.getChartData(this.selectedSource[j].name);

        series_value.forEach(function (el, i) {
          if (el === "") {
            el = 0;
          }
        });
        // console.log(series_value);

        var series_data = {
          name: this.selectedSource[j].name,
          data: series_value
        };

        // console.log(series_data);

        this.optionsObj.series.push(series_data);
        // console.log(this.optionsObj.series);
      }
    },
    getYearOptions: function getYearOptions(data, selectedIndicator) {
      var yearArray = [];
      var indexOfindicatorSource = this.lsData[0].indexOf(selectedIndicator) - 1;
      data.map(function (elem, index) {
        if (elem[indexOfindicatorSource] !== "" && indexOfindicatorSource > -1) {
          yearArray.push(elem[0]);
        }
      });

      return yearArray.sort(function (a, b) {
        return b - a;
      });
    },
    getChartData: function getChartData(selectedSource) {
      // var dataArray = []; //previous implementation
      var dataArray2 = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      var selectedSourceAndYear = selectedSource.split(":");
      var indicatorSource = this.selectedIndicator.name + " -> " + selectedSourceAndYear[0];
      var indexOfIndicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
      this.optionStates.map(function (element, index) {
        var stateData = statesByIndicatorByYear[element];

        stateData.map(function (elem, index) {
          if (indexOfIndicatorSource > -1 && elem[0] === parseFloat(selectedSourceAndYear[1])) {
            dataArray2.push([element, elem[indexOfIndicatorSource]]);
            // console.log(element +" - "+ elem[indexOfIndicatorSource]);
          }
        });
      });
      var stateOptions = [];
      // this.getCurrentSourceOptions();

      if (!(Array.isArray(this.selectedSource) && this.selectedSource.length > 1)) {
        var tempArray = dataArray2.slice(1);
        tempArray.sort(function (a, b) {
          return b[1] - a[1];
        });

        tempArray.unshift(dataArray2[0]);
        dataArray2 = tempArray;

        stateOptions = dataArray2.map(function (el, ind) {
          return el[0];
        });

        this.optionStates = stateOptions;
      }

      return dataArray2;
    }
  },
  computed: {
    multiselectPlaceholderComputed: function multiselectPlaceholderComputed() {
      this.multiselectPlaceholder = this.selectedIndicator.name;
      this.sourceMultiselectPlaceholder = "";
    }
  },
  created: function created() {
    // get the program area indicator grouping
    this.dataSources = this.optionSources;
  },
  mounted: function mounted() {
    if (this.dashboardStateOptions.length > 0) {
      if (this.dashboardStateOptions[4].indexOf("_") > 0) {
        this.selectedIndicator.name = this.dashboardStateOptions[4].replace("_", "/");
      } else {
        this.selectedIndicator.name = this.dashboardStateOptions[4];
      }
      if (this.dashboardStateOptions[3].indexOf(",") > 0) {
        var selectedSource = this.dashboardStateOptions[1].split(",");
        // console.log(selectedSource);
        this.selectedSource = [];
        for (var i in selectedSource) {
          var tempSourceObj = {
            name: selectedSource[i]
          };
          this.selectedSource.push(tempSourceObj);
        }
      } else {
        this.selectedSource.name = this.dashboardStateOptions[3];
      }
    } else {
      this.selectedIndicator.name = "Skilled attendance at delivery or birth";
    }
    this.$emit("columnChartIndicator", this.selectedIndicator.name);
    if (this.appData) {
      this.optionIndicators = this.optionsIndicator;
      this.getCurrentSourceOptions();
      if (this.dashboardStateOptions[3]) {
        if (this.dashboardStateOptions[3].indexOf(",") > 0) {
          var _selectedSource = this.dashboardStateOptions[1].split(",");
          this.selectedSource = [];
          for (var i in _selectedSource) {
            var _tempSourceObj = {
              name: _selectedSource[i]
            };
            this.selectedSource.push(_tempSourceObj);
          }
        } else {
          this.selectedSource.name = this.dashboardStateOptions[3];
        }
      } else {
        //console.log(this.optionsSource[0])
        var years = [];
        for (var i in this.optionsSource[1].years) {
          var tempYear = this.optionsSource[1].years[i].name.split(":");
          years.push(tempYear[1]);
        }

        var currentYear = Math.max.apply(null, years);
        this.selectedSource = {
          name: this.optionsSource[3].sources + ":" + currentYear
        };
      }
      if (Array.isArray(this.selectedSource) && this.selectedSource.length > 1) this.onSourceChangedMethod();else {
        this.plotZonalChart();
      }
    }
    this.$emit("callerName", "columnChartIndicator");
    this.$emit("columnChartIndicator", this.selectedIndicator.name);
  },
  updated: function updated() {},

  watch: {
    //feeds ndOptions to numerator-denominator
    optionsSource: function optionsSource(val) {
      //  console.log(val);
      __WEBPACK_IMPORTED_MODULE_6__main_js__["eventBus"].$emit("ndOptionsEvent", val);
    },
    selectedSource: function selectedSource(name) {
      if (this.lsData) {
        this.$emit("callerName", "columnChartSource");
        this.$emit("columnChartSource", name);
        if (Array.isArray(name) && name.length > 1) this.onSourceChangedMethod();else {
          this.plotZonalChart();
        }
      }
    },
    appData: function appData(val) {
      if (val) {
        this.lsData = val;
        this.optionIndicators = this.optionsIndicator;
        this.getCurrentSourceOptions();
        if (this.dashboardStateOptions[3]) {
          if (this.dashboardStateOptions[3].indexOf(",") > 0) {
            var selectedSource = this.dashboardStateOptions[3].split(",");
            this.selectedSource = [];
            for (var i in selectedSource) {
              var tempSourceObj = {
                name: selectedSource[i]
              };
              this.selectedSource.push(tempSourceObj);
            }
          }
        } else {
          var years = [];
          for (var i in this.optionsSource[3].years) {
            var tempYear = this.optionsSource[3].years[i].name.split(":");
            years.push(tempYear[1]);
          }
          var currentYear = Math.max.apply(null, years);
          this.selectedSource = {
            name: this.optionsSource[3].sources + ":" + currentYear
          };
        }
        if (Array.isArray(this.selectedSource) && this.selectedSource.length > 1) this.onSourceChangedMethod();else {
          this.plotZonalChart();
        }
        if (this.metaData) {
          this.getDisplayFactor();
        }
      }
    },
    "selectedIndicator.name": function selectedIndicatorName(val) {
      this.selectedYear = Math.max.apply(null, this.yearOptions);
      this.getCurrentSourceOptions();
      if (this.dashboardStateOptions[3]) {
        if (this.dashboardStateOptions[3].indexOf(",") > 0) {
          var selectedSource = this.dashboardStateOptions[3].split(",");
          this.selectedSource = [];
          for (var i in selectedSource) {
            var tempSourceObj = {
              name: selectedSource[i]
            };
            this.selectedSource.push(tempSourceObj);
            // console.log(tempSourceObj);
          }
        }
      } else {
        var years = [];
        var theSource = [];
        var mics_index = 0;
        for (var i = 0; i < this.optionsSource.length; i++) {
          theSource.push(this.optionsSource[i].sources);
          mics_index = theSource.indexOf("MICS");
        }
        if (mics_index !== -1) {
          for (var i in this.optionsSource[mics_index].years) {
            var tempYear = this.optionsSource[mics_index].years[i].name.split(":");
            years.push(tempYear[1]);
          }
        } else {
          for (var i in this.optionsSource[0].years) {
            var _tempYear = this.optionsSource[0].years[i].name.split(":");
            years.push(_tempYear[1]);
          }
        }

        var currentYear = Math.max.apply(null, years);
        if (mics_index !== -1) {
          this.selectedSource = { name: "MICS:" + currentYear };
        } else {
          this.selectedSource = {
            name: "" + this.optionsSource[0].years[0].name
          };
        }

        // console.log(this.selectedSource);
      }
      this.plotZonalChart();
      this.$emit("callerName", "columnChartIndicator");
      this.$emit("columnChartIndicator", val);
      if (this.metaData) {
        this.getDisplayFactor();
      }
    },
    optionsIndicator: function optionsIndicator(val) {
      this.optionIndicators = val;
    },
    meta_data: function meta_data(val) {
      if (val) {
        this.metaData = val;
        this.getDisplayFactor();
      }
    },
    dashboardStateOptions: function dashboardStateOptions(val) {
      if (val) {
        if (val[4].indexOf("_") > 0) {
          this.selectedIndicator.name = val[4].replace("_", "/");
        } else {
          this.selectedIndicator.name = val[4];
        }
        if (val[3].indexOf(",") > 0) {
          var selectedSource = val[3].split(",");
          this.selectedSource = [];
          for (var i in selectedSource) {
            var tempSourceObj = {
              name: selectedSource[i]
            };
            this.selectedSource.push(tempSourceObj);
          }
        } else {
          this.selectedSource.name = val[3];
        }
      } else {
        this.selectedIndicator.name = "Skilled attendance at delivery or birth";
      }
      this.$emit("columnChartIndicator", this.selectedIndicator.name);
    },
    contextSelectedIndicator: function contextSelectedIndicator(val) {
      this.selectedIndicator = val;
    }
  }
});

/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(804)(true);
// imports


// module
exports.push([module.i, "div[class^=col][data-v-6d000bc2]{padding-left:7px;padding-right:7px}.rowlTop[data-v-6d000bc2]{margin-bottom:-30px!important}.rowlBot[data-v-6d000bc2]{margin-top:-30px!important}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/columnChart.vue"],"names":[],"mappings":"AACA,iCACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,0BACE,6BAAgC,CACjC,AACD,0BACE,0BAA6B,CAC9B","file":"columnChart.vue","sourcesContent":["\ndiv[class^=\"col\"][data-v-6d000bc2] {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n.rowlTop[data-v-6d000bc2] {\n  margin-bottom: -30px !important;\n}\n.rowlBot[data-v-6d000bc2] {\n  margin-top: -30px !important;\n}\n\n/* Some styles live in App.vue file*/\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(904);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("539c6ec2", content, true, {});

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d000bc2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 969:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper zonal-wrapper"
  }, [_c('div', {
    staticClass: "chart-title zonal-chart"
  }, [_c('label', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.multiselectPlaceholderComputed))]), _vm._v(" "), _c('div', {
    staticClass: "text-center web-features columnchart-label"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-5 multi-select_x1"
  }, [_c('multi-select', {
    staticStyle: {
      "transform": "scale(0.9)",
      "font-weight": "normal"
    },
    attrs: {
      "options": _vm.optionIndicators,
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible": _vm.collapsible,
      "group-collapsible-expanded": false,
      "show-labels": false,
      "placeholder": _vm.multiselectPlaceholder,
      "allow-empty": false,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "search-change": function($event) {
        _vm.multiselectSearch()
      },
      "close": function($event) {
        _vm.closedMultiselect(_vm.selectedIndicator.name)
      },
      "open": _vm.openedMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('multi-select', {
    staticClass: "autoMaxHeight",
    staticStyle: {
      "transform": "scale(0.9)",
      "font-weight": "normal"
    },
    attrs: {
      "options": _vm.optionsSource,
      "group-values": "years",
      "group-label": "sources",
      "multiple": true,
      "group-collapsible": true,
      "placeholder": _vm.sourceMultiselectPlaceholder,
      "showInput": false,
      "group-collapsible-expanded": false,
      "max": 4,
      "allow-empty": false,
      "show-labels": false,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "open": _vm.openedSourceMultiselect,
      "close": function($event) {
        _vm.closedSourceMultiselect(_vm.selectedSource.name)
      }
    },
    model: {
      value: (_vm.selectedSource),
      callback: function($$v) {
        _vm.selectedSource = $$v
      },
      expression: "selectedSource"
    }
  }, [_c('span', {
    attrs: {
      "slot": "maxElements"
    },
    slot: "maxElements"
  }, [_vm._v("Maximum of four selections")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chart-stage column-chart-container"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.optionsObj
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-3 text-xs-center title_placement"
  }, [_c('h4', {
    staticClass: "white--text"
  }, [_vm._v("\n            MULTI-DATASET COMPARISON SECTION\n          ")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/16.5ffcc41743712abe0d24.js